import styled from 'styled-components';
import { gap } from '../../../../juristec-ui/styles/theme';
import { devices } from '../../../../juristec-ui/core/breakpoints';

const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export const MainContainer = styled(Row)`
  padding: 1.5rem 5%;
  ${gap('30px', 'row')}
  align-items: center;
  & .left {
    width: 100%;
    flex-shrink: 2;
    position: relative;
    & span {
      position: absolute;
      font-size: 12px;
      font-weight: bold;
      margin-left: 20px;
      color: ${({ theme }) => theme.color};
    }
  }
  & .right {
    flex-grow: 5;
    flex-shrink: 1;
  }
  @media ${devices.tablet} {
    padding: 1.5rem 20px;
  }
  @media ${devices.phoneS} {
    // gap: 10px;
    ${gap('0', 'row')}
    ${gap('10px', 'column')}
        flex-direction: column;
    & .left span {
      position: initial;
      margin-left: 0;
      white-space: nowrap;
      color: ${({ theme }) => theme.grey};
    }
    & .right {
      width: 100%;
    }
    padding: 10px 20px;
  }
`;

export const ItensContainer = styled(Row)`
  ${gap('10px', 'row')}
  align-items: center;
`;

export const ProgressContainer = styled(Row)`
  background-color: ${({ theme }) => theme.backgroundOdd};
  box-shadow: 0px 4px 4px ${({ theme }) => theme.shadow};
  width: 100%;
  height: 36px;
  border-radius: 8px;
  align-items: center;
  overflow: hidden;
  flex-grow: 1;
  flex-shrink: 5;
  @media ${devices.phoneS} {
    height: 15px;
  }
`;

export const ProgressBar = styled(Row)`
  width: ${(props) => props.position + 10}%;
  height: 36px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.secondary};
  margin-left: -10%;
  @media ${devices.phoneS} {
    height: 15px;
  }
`;

export const SearchBarContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  ${gap('.5rem', 'row')}
  background-color: ${({ theme }) => theme.backgroundOdd};
  border-radius: 10px;
  box-shadow: 0px 4px 4px ${({ theme }) => theme.shadow};
  padding: 0.2rem 0.6rem;
  & svg {
    height: 20px;
    width: 20px;
    fill: ${({ theme }) => theme.grey};
  }
  & .inputTxt {
    padding-top: 5px;
  }
  @media ${devices.phoneS} {
    width: 100%;
    & div:last-child {
      width: 100%;
    }
    & .inputTxt {
      width: 100%;
    }
  }
`;

export const IconWrapper = styled.div`
  width: 20px;
  height: 20px;
`;
